import { Injectable, InjectionToken, inject, PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'

export const BROWSER_SESSION_STORAGE = new InjectionToken<Storage | undefined>('Browser session storage', {
  providedIn: 'root',
  factory: (): Storage | undefined => {
    const platformId = inject(PLATFORM_ID)
    if (isPlatformBrowser(platformId)) {
      return sessionStorage as Storage
    }
    return undefined
  },
})

@Injectable({
  providedIn: 'root',
})
export class BrowserSessionStorageService {
  private storage = inject<Storage | undefined>(BROWSER_SESSION_STORAGE)

  get(key: string) {
    return this.storage?.getItem(key)
  }

  set(key: string, value: string) {
    this.storage?.setItem(key, value)
  }

  remove(key: string) {
    this.storage?.removeItem(key)
  }

  clear() {
    this.storage?.clear()
  }

  keys(): string[] {
    return this.storage ? Object.keys(this.storage) : []
  }
}
